import clsx from 'clsx';

export interface IStatCardProps {
  value: string | number;
  label: string;
  valueClassName?: string;
  subLabel?: string;
  variant?: 'muted' | 'default';
  className?: string;
}

const StatCard = ({
  value,
  label,
  valueClassName,
  subLabel,
  variant = 'muted',
  className,
}: IStatCardProps) => (
  <div
    className={clsx(
      'rounded-xl border border-gray-200 px-3 py-3',
      variant === 'muted' ? 'bg-gray-50' : 'bg-white',
      className
    )}
  >
    <div
      className={clsx(
        'text-2xl font-bold tabular-nums leading-tight',
        valueClassName || 'text-gray-900'
      )}
    >
      {value}
    </div>
    <div className='mt-1 text-xs font-semibold uppercase tracking-wide text-gray-500'>
      {subLabel ? (
        <>
          <span className='normal-case tracking-normal text-sm font-semibold text-gray-800'>
            {subLabel}
          </span>
          <span className='mx-1'>·</span>
          {label}
        </>
      ) : (
        label
      )}
    </div>
  </div>
);

export default StatCard;
